
import Vue from "vue";
import { Component } from "vue-property-decorator";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import { RCP, getRCPList } from "./rcpService";

@Component({
  components: {
    PulseLoader
  },
})
export default class AnnuaireRCPForm extends Vue {

  private rcpList: RCP[] = [];
  private isLoading = false;
  private imgPath = "wp-content/themes/ressources/assets/src/images/Logo-DCC-onco-aura.png";

  public mounted() {
    this.isLoading = true;
    this.$http.get("/ajax-get-annuaire-rcp")
        .then(response => {
          this.rcpList = getRCPList(response.data.result);
          this.filterRCPData();
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
  }


  //Multiselect Région anatomique
  private valueRegionAnatomique = [];
  get optsRegionAnatomique() {
    return this.rcpList
      .map(({ RegionAnatomique }) => RegionAnatomique)
      .filter(this.onlyUnique);
  }

  //Multiselect Groupement 3C
  private valueGroupement3C = [];
  get optsGroupement3C() {
    return this.rcpList
      .map(({ Groupement3C }) => Groupement3C)
      .filter(this.onlyUnique);
  }

  //Multiselect Etablissement de rattachement
  private valueEtablissement = [];
  get optsEtablissement() {
    return this.rcpList
      .map(({ Etablissement }) => Etablissement)
      .filter(this.onlyUnique);
  }

  //Datatable résultats RCP
  private resultRCPColumns: string[] = [
    "Libelle",
    "Etablissement",
    "Departement",
    "Groupement3C",
    "RegionAnatomique",
    "Coordonnateur",
    "Secretaire",
    "EmailSecretariat",
  ];
  private resultRCPData: RCP[] = [];
  private resultRCPOptions = {
    headings: {
      Libelle: "RCP",
      Etablissement: "Etablissement de rattachement",
      Departement: "Département",
      Groupement3C: "Groupement 3C",
      RegionAnatomique: "Région anatomique",
      Coordonnateur: "Médecin coordonnateur",
      Secretaire: "Secrétariat",
      EmailSecretariat: "Mail Secrétariat",
    },
    filterable: false,
    sortable: [
      "Libelle",
      "Etablissement",
      "Departement",
      "Groupement3C",
      "RegionAnatomique",
      "Coordonnateur",
      "Secretaire",
      "EmailSecretariat",
    ],
    orderBy: {
      column: "Groupement3C",
      ascending: true,
    },
    multiSorting: {
      multiSort: [{
          column: "Etablissement",
          matchDir: true,
        },
        {
          column: "Libelle",
          matchDir: true,
        },
      ],
    },
    footerHeadings: true,
    sortIcon: {
      base: "fa",
      is: "fa-sort",
      up: "fa-sort-up",
      down: "fa-sort-down",
    },
    texts: {
      count:
        "{from}-{to} sur {count} résultats trouvés|{count} résultats|Un seul résultat trouvé",
      limit: "Résultats:",
      page: "Page:",
      noResults: "Aucun résultat trouvé",
      loading: "Chargement en cours...",
    },
  };

  filterRCPData() {
    //Si aucun filtre rempli, on renvoit tout les résultats
    if (
      this.valueRegionAnatomique.length === 0 &&
      this.valueGroupement3C.length === 0 &&
      this.valueEtablissement.length === 0
    ) {
      this.resultRCPData = [...this.rcpList];
    } else {
      this.resultRCPData = this.rcpList.filter((rcp: RCP) => {
        let OKRegionAnatomique = true;
        if (this.valueRegionAnatomique.length > 0) {
          OKRegionAnatomique =
            this.valueRegionAnatomique.findIndex(
              (val) => val === rcp.RegionAnatomique
            ) !== -1;
        }
        let OKGroupement3C = true;
        if (this.valueGroupement3C.length > 0) {
          OKGroupement3C =
            this.valueGroupement3C.findIndex(
              (val) => val === rcp.Groupement3C
            ) !== -1;
        }
        let OKEtablissement = true;
        if (this.valueEtablissement.length > 0) {
          OKEtablissement =
            this.valueEtablissement.findIndex(
              (val) => val === rcp.Etablissement
            ) !== -1;
        }
        return OKRegionAnatomique && OKGroupement3C && OKEtablissement;
      });
    }
  }

  resetRCPData() {
    this.valueRegionAnatomique = [];
    this.valueGroupement3C = [];
    this.valueEtablissement = [];
  }

  onlyUnique(value: any, index: any, self: any) {
    return self.indexOf(value) === index;
  }
}
